// import Cookies from 'universal-cookie';
// const cookies = new Cookies();

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) return undefined;
    // console.log("iphone 10.2 state");
    console.log(JSON.parse(serializedState));
    return JSON.parse(serializedState);
    // return undefined;
  } catch (err) {
    // console.log('iphone 10.2 state '+err)
    return undefined;
  }
};

export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("state", serializedState);
    // console.log('trying to save cookie');
    // console.log(state);
    // if (state.user !== null) cookies.set('token', state.user.jwt_token || null);
  } catch (err) {
    console.log(err);
  }
};

export const getStateValue = key => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) return undefined;
    const state = JSON.parse(serializedState);
    return state[key];
  } catch (err) {
    console.log(err);
    return undefined;
  }
};

export const updateStateValue = (key, value) => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) return undefined;
    const state = JSON.parse(serializedState);
    //return state[key];
    state[key] = value;
    return;
  } catch (err) {
    console.log(err);
    return undefined;
  }
};



// WEBPACK FOOTER //
// ./src/root/localStorage.js